import React from 'react';
import { useHistory } from 'react-router-dom';
import { createStyles, makeStyles } from '@material-ui/core';
import { ExtendedTheme, TextBlock, MessageView } from 'neon-design-system';
import { baseUrls } from '../../../utils/baseUrls.utils';
import { topicsOrCategories } from '../../../utils/utils';

const useStyles = makeStyles<ExtendedTheme>((theme: ExtendedTheme) => createStyles({

	noArticles: {
		margin: '0 auto',
		paddingTop: theme.spacing(6),
		paddingBottom: theme.spacing(6),
		backgroundColor: theme.palette.grey[800]
	}
}));

interface NoArticlesPlaceholderProps {
	isChannel?: boolean;
}

export const NoArticlesPlaceholder: React.FC<NoArticlesPlaceholderProps> = ({ isChannel}) => {
	const classes = useStyles();
	const { push } = useHistory();

	return (<div className={classes.noArticles}>
		<MessageView
			styleName="primary"
			size="medium"
			title="No articles yet"
			primaryAction={{
				label: `Browse ${isChannel ? 'Channels' : topicsOrCategories(true)}`,
				onClick: () => { push(baseUrls.channels.main) }
			}}>
			<TextBlock
				styleName="body"
				xs="small" sm="medium"
				color="grey"
				shade={400}
			>
				This {isChannel ? 'Channel' : topicsOrCategories()} hasn’t received contributions yet. You can search articles or explore the available {isChannel ? 'channels' : topicsOrCategories(true)}.
			</TextBlock>
		</MessageView></div>);
}

export default NoArticlesPlaceholder;
